<template>
  <div>
    <div class="header-wrapper">
      <div class="header">便民电话</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="addPhone()">新增电话</Button>
      </div>
    </div>
    <div>
      <Row type="flex" justify="start" ref="cardgroup" class="cardgroup">
        <Col v-for="(item,index) in phoneList" :key="index" :style="{'margin-left':marginLeft}">
          <Card class="card-wrapper" :padding="padding" :style="{width:cardItemWidth+'px'}">
            <div class="box card-box" @mouseover="cardHover(index)" @mouseout="cardOut(index)">
              <div class="hover box" v-show="item.hover">
                <div class="iconfont icon-qiandao" @click="bianji(item)"></div>
                <div class="iconfont icon-chushaixuanxiang" @click="delPhone(item.id)"></div>
              </div>
              <img :src="item.url"/>
              <div class="box_f1 box_v phone-detail">
                <div class="name">{{item.name}}</div>
                <div class="timeAndphone">
                  <div style="margin-bottom: 15px">
                    <i class="iconfont icon-dengdai"></i>{{item.startDayNum}}至{{item.endDayNum}}&nbsp;{{item.startTime}}-{{item.endTime}}
                  </div>
                  <div>
                    <i class="iconfont icon-dianhua"></i>{{item.phone}}
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
    <add-model :showModel="showModel" :phone-item="phoneItem" :picList="picList"></add-model>
    <infinite-loading :identifier="newRule" @infinite="loadMore">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
  import addModel from './components/addPhone'

  export default {
    name: 'bianminPhone',
    components: {addModel},
    data() {
      return {
        showModel: false,
        cardItemWidth: 410, // 设为0 可动态获取 宽度
        marginLeft: "",
        padding: 0,
        phoneItem: {},
        picList: [],
        phoneList: [],
        newRule: 0,
        page: 1,
        rows: 10,
      }
    },
    watch: {
      phoneList: function () {
        //  没有初始化时执行
        if (!this.cardItemWidth) {
          // 有数据时执行
          if (this.$refs.cardgroup.$children.length > 0) {
            this.cardItemWidth = this.$refs.cardgroup.$children[0].$el.clientWidth;
            this.getMargin();
          }
        }
      }
    },
    methods: {
      loadMore(loadingContext) {
        this.getPhoneList(loadingContext);
      },
      //点击新增按钮
      addPhone() {
        this.phoneItem = {}
        this.picList.forEach(_item => {
            _item.isSelect = false
        })
        this.showModel = true
      },
      //关闭弹窗
      closeModel() {
        this.showModel = false
      },
      //计算边距 响应式
      getMargin() {
        this.$nextTick()
          .then(() => {
            if (this.$refs.cardgroup) {
              let boxWidth = this.$refs.cardgroup.$el.clientWidth;//内容宽度
              let count = Math.floor(boxWidth / this.cardItemWidth) + 1;//一行能放几个card  就有几个左边距  还要加上最后一个card的右边距
              let rest = boxWidth % this.cardItemWidth;//余数就是边距总共占的距离
              this.marginLeft = rest / count + "px";
            }
          })
          .catch(e => console.log(e));
      },
      //鼠标悬浮卡片上  显示编辑 删除按钮
      cardHover(index) {
        this.phoneList[index].hover = true;
      },
      //鼠标离开卡片  隐藏编辑 删除按钮
      cardOut(index) {
        this.phoneList[index].hover = false;
      },
      //点击卡片编辑按钮
      bianji(item) {
        this.phoneItem = item
        console.log(this.phoneItem)
        this.picList.forEach(_item => {
          if (_item.url == item.url) {
            _item.isSelect = true
          }else {
            _item.isSelect = false
          }
        })
        this.showModel = true
      },
      //获取所有图片
      getPicList() {
        var url = this.urlobj.dictionaryList('phone_title')
        this.$get(url).then(res => {
          this.picList = res.rows.map(item => {
            return {
              url: item.headPicUrl,
              id: item.id,
              isSelect: false
            }
          })
        })
      },
      //获取电话列表
      getPhoneList(loadingContext) {
        var that = this
        var url = this.urlobj.getPhoneList
        this.$post(url, {
          pageNum: that.page,
          pageSize: that.rows,
        }).then(res => {
          if (res.rows.length) {
            that.page++;
            loadingContext.loaded(); // 结束加载状态
            var phoneList = res.rows.map(item => {
              return {
                id:item.id,
                name: item.title,
                startDay: item.beginWeek,
                endDay: item.endWeek,
                startTime: item.beginTime.substring(0,5),
                endTime: item.endTime.substring(0,5),
                startDayNum:that.handelWeek(item.beginWeek),
                endDayNum:that.handelWeek(item.endWeek),
                phone: item.phoneNO,
                hover: false,
                url:item.headPicUrl
              }
            })
            that.phoneList = that.phoneList.concat(phoneList)
          } else {
            /* 如果没有数据 完成加载 */
            loadingContext.complete();
          }
        })
      },
      //处理每周数据
      handelWeek(num) {
        switch (num) {
          case 0 :
            return '周日'
            break;
          case 1:
            return '周一';
            break;
          case 2:
            return '周二';
            break;
          case 3:
            return '周三';
            break;
          case 4:
            return '周四';
            break;
          case 5:
            return '周五';
            break;
          case 6:
            return '周六';
            break;
        }
      },
      //处理选择图片事件  被选择的图片显示右上角已选择图标
      selectPic(ind) {
        this.picList.forEach((item, index) => {
          if (index == ind) {
            item.isSelect = true
          } else {
            item.isSelect = false
          }
        })
      },
      //保存成功
      saveSuccess() {
        this.showModel = false
        this.phoneList = []
        this.page = 1
        this.newRule++
      },
      delPhone (id) {
        var url = this.urlobj.delPhone(id)
        this.$delete(url).then(res => {
          if (res.isSucceed) {
            this.$Message.success('删除成功')
            this.phoneList = []
            this.page = 1
            this.newRule++
          }else {
            this.$Message.error('删除失败，请重试')
          }
        })
      }
    },
    mounted() {
      this.getMargin();
      window.onresize = this.getMargin;
      this.getPicList()
    }
  }
</script>

<style scoped lang="less">
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }

  .header {
    font-size: 25px;
    text-align: center;
  }

  .addManager {
    position: absolute;
    right: 20px;
  }

  .content {
    /*padding: 0 20px;*/
    /*flex-wrap: wrap;*/
  }

  .card-wrapper {
    margin-bottom: 20px;
    img {
      height: 60px;
      width: 60px;
      margin-right: 20px;
    }
  }

  .card-box {
    min-height: 140px;
    padding: 20px;
    box-sizing: border-box;
  }

  .phone-detail {

    justify-content: space-between;
    .name {
      font-size: 18px;
      word-break: break-all;
    }
    .timeAndphone {
      line-height: 1;
      font-size: 16px;
      color: #999;
      .iconfont {
        color: #ccc;
        margin-right: 10px;
      }
    }
  }

  .hover {
    position: absolute;
    top: 20px;
    right: 20px;
    .iconfont {
      color: #ccc;
      &:first-child {
        line-height: 1;
        font-size: 25px;
        margin-right: 10px;
      }
    }
  }
</style>
